import AWS from 'aws-sdk';
import { ProductMetaData } from './interfaces/components';

const AWS_REGION = 'eu-west-2';
const AWS_IDENTITY_POOL_ID = 'eu-west-2:621bd410-77f2-40b2-bb4f-79f04f8d9ac6';
const DELIVERY_STREAM = 'emperia-user-analytics-stream';
let firehoseClient: AWS.Firehose | undefined = undefined;

export type AnalyticsItem = {
  item_id: string;
  item_name: string;
  affiliation: string;
  coupon: string;
  currency: string;
  discount: number;
  index: number;
  item_brand: string;
  item_category: string;
  item_list_id: string;
  item_list_name: string;
  item_variant: string;
  location_id: string;
  price: number;
  quantity: number;
};

export type FirehoseAnalyticsItem = {
  org_name: string;
  exp_name: string;
  product_id: string;
  product_title: string;
  room: string;
  browser: string;
  device: string;
  date: string;
  time: string;
  type: string;
};

export type PostMessageItem = {
  product_id: string;
  color_id: string;
  title: string;
  price: string;
  size_mpn: string;
  gtin: string;
};

export function dispatchExternalLinkAnalytics(url: string) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'external_link',
    gtm: {
      elementUrl: url,
    },
  });
}

export function dispatchViewItemAnalytics(
  currency = 'USD',
  value: string,
  analyticItems: Array<AnalyticsItem>,
  productMetaData: ProductMetaData,
) {
  triggerDataToKinesis(analyticItems, productMetaData, 'viewitem');
  window.dataLayer = window.dataLayer || [];
  console.log({
    event: 'view_item',
    ecommerce: {
      items: analyticItems,
      currency: currency,
      value: value,
    },
  });
  window.dataLayer.push({
    event: 'view_item',
    ecommerce: {
      items: analyticItems,
      currency: currency,
      value: value,
    },
  });
}

export function dispatchAddToCartAnalytics(
  currency = 'USD',
  value: string,
  analyticItems: Array<AnalyticsItem>,
  productMetaData: ProductMetaData,
) {
  triggerDataToKinesis(analyticItems, productMetaData, 'addtocart');
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  console.log({
    event: 'add_to_cart',
    ecommerce: {
      items: analyticItems,
      currency: currency,
      value: value,
    },
    potentialValue: value,
  });
  window.dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      items: analyticItems,
      currency: currency,
      value: value,
    },
    potentialValue: value,
  });
}

export function dispatchSelectContentAnalytics(type: string, id: string) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'select_content',
    content_type: type,
    item_id: id,
  });
}

export function dispatchTryOnAnalytics(momentiUrl: string, partnership: string, analyticItems?: Array<AnalyticsItem>) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  console.log({
    event: 'open_additional_media',
    ecommerce: {
      items: analyticItems,
    },
    partnership: partnership,
    url: momentiUrl,
  });
  window.dataLayer.push({
    event: 'open_additional_media',
    ecommerce: {
      items: analyticItems,
    },
    partnership: partnership,
    url: momentiUrl,
  });
}

export function dispatchCollectItemAnalytics(collectedItem: string, roomName: string, progress: string) {
  window.dataLayer = window.dataLayer || [];
  console.log({
    event: 'collect_item',
    item_name: collectedItem,
    room: roomName,
    room_name: roomName,
    progress: progress,
  });
  window.dataLayer.push({
    event: 'collect_item',
    item_name: collectedItem,
    room: roomName,
    room_name: roomName,
    progress: progress,
  });
}

export function dispatchAudioAnalytics(audioEnabled: boolean) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'enable_audio',
    audioEnabled: audioEnabled,
  });
}

export function triggerDataToKinesis(
  analyticsItems: Array<AnalyticsItem>,
  productMetaData: ProductMetaData,
  analyticsType: string,
) {
  const analyticsObj: Array<FirehoseAnalyticsItem> = [];
  const today = new Date(Date.now()).toLocaleString('en-GB');
  const currentDate = today.split(',')[0].replaceAll('/', '-');
  const currentTime = today.split(',')[1];
  analyticsItems.forEach((analyticsItem: AnalyticsItem) => {
    analyticsObj.push({
      org_name: productMetaData.organisationName as string,
      exp_name: productMetaData.experienceName as string,
      product_id: analyticsItem.item_id,
      product_title: analyticsItem.item_name,
      browser: productMetaData.browser,
      device: productMetaData.os,
      room: productMetaData.roomName,
      date: currentDate,
      time: currentTime,
      type: analyticsType,
    });
  });
  if (firehoseClient == undefined) {
    initializeFirehoseClient();
  }
  firehoseClient?.putRecord(
    {
      Record: { Data: JSON.stringify(analyticsObj[0]) },
      DeliveryStreamName: DELIVERY_STREAM,
    },
    function (err, data) {
      if (err) console.log(err, data);
    },
  );
}

export function initializeFirehoseClient() {
  const creds = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: AWS_IDENTITY_POOL_ID,
  });
  AWS.config.update({
    region: AWS_REGION,
    credentials: creds,
  });
  firehoseClient = new AWS.Firehose();
}
